import React, { FC } from "react";
import { LabelStyled } from "./Label.style";
import { ILabelProps } from "./Label.types";

const Label: FC<ILabelProps> = ({ value, id }) => {
  return <LabelStyled htmlFor={id}>{value}</LabelStyled>;
};

export default Label;
